export const httpAccepted = 202;
export const httpNoContent = 204;
export const httpNotFound = 404;
